<template>
    <div id="admin-ratings">
        <div class="admin-ratings-col1">
            <h2>Öll vín</h2>
            <div class="admin-ratings-wines">
                <div class="admin-ratings-wines-single" v-for="wine in wines" :key="wine.id" v-on:click="openModal(wine)">
                    <div class="admin-ratings-wines-img"><img :src="wine.image | optimizeWine"></div>
                    <div class="admin-ratings-wines-info">
                        <div class="admin-ratings-wines-name">{{ wine.name }}</div>
                        <div class="admin-ratings-wines-avg-title">Meðaleinkunn</div>
                        <div class="admin-ratings-wines-count-title">Fjöldi</div>
                        <div class="admin-ratings-wines-avg">{{ getAvgRating(wine.id).avg }}</div>
                        <div class="admin-ratings-wines-count">{{ getAvgRating(wine.id).len }}</div>
                    </div>
                    <!-- <div v-for="rating in findRatingsFromWine(wine.id)" :key="rating.date">
                        {{ rating.date }} - {{ rating.rating }}
                    </div> -->
                </div>
            </div>
        </div>
        <div class="admin-ratings-col2">
            <h2>Seinustu Einkunnagjafir</h2>
            <div class="admin-recent-ratings">
                <div  v-for="rating in sortByDate(ratings)" :key="rating.id">
                    <div class="admin-single-rating" v-if="findWineFromRating(rating.wineid)">
                        <div class="admin-single-rating-img"><img :src="findWineFromRating(rating.wineid).image | optimizeWine"/></div>
                        <div class="admin-single-rating-info">
                            <div class="admin-single-rating-name">{{ findWineFromRating(rating.wineid).name }}</div>
                            <div class="admin-single-rating-date">{{ displayDate(rating.date) }}</div>
                        </div>
                        <div class="admin-single-rating-rating">{{ rating.rating }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="admin-ratings-modal-wrap" v-if="modal">
            <div class="admin-ratings-modal">
                <div class="admin-ratings-modal-close" v-on:click="closeModal">Loka</div>
                <div class="admin-ratings-modal-content">
                    <div class="admin-single-rating" v-for="rating in sortByDate(currentWine.ratings)" :key="rating.id">
                        <div class="admin-single-rating-img"><img :src="findWineFromRating(rating.wineid).image | optimizeWine"/></div>
                        <div class="admin-single-rating-info">
                            <div class="admin-single-rating-name">{{ findWineFromRating(rating.wineid).name }}</div>
                            <div class="admin-single-rating-date">{{ displayDate(rating.date) }}</div>
                        </div>
                        <div class="admin-single-rating-rating">{{ rating.rating }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    data() {
        return {
            currentWine: {
                wine: null,
                ratings: null
            },
            modal: false,
            sort: 0
        }
    },
    computed: {
        ...mapState(['ratings', 'wines'])
    },
    methods: {
        findWineFromRating(id) {
            /* Returns a single wine object */
            for (let i = 0; i < this.wines.length; i++) {
                const element = this.wines[i];
                if (element.id == id) {
                    return element  
                }
            }
            return false
        },
        findRatingsFromWine(id) {
            /* Returns an array of rating objects */
            var ratingsArray = []
            for (let i = 0; i < this.ratings.length; i++) {
                const element = this.ratings[i];
                if (element.wineid == id) {
                    ratingsArray.push(element)
                }
            }
            return ratingsArray
        },
        sortByDate(array) {
            var copyArray = array.slice()
            copyArray.sort(function(a,b){return Date.parse(b.date) - Date.parse(a.date)})
            return copyArray
        },
/*         sortWines(array) {
            var copyArray = array.slice()
            // Sort by rating highest first
            if (this.sort == 1) {
                copyArray.sort((a, b) => (b.rating > a.rating) ? 1 : -1)
                return copyArray
            }
            // Sort by rating lowest first
            else if (this.sort == 2) {
                copyArray.sort((a, b) => (a.rating > b.rating) ? 1 : -1)
                return copyArray
            }
            // Sort by name 
            else if (this.sort == 3) {
                copyArray.sort((a, b) => (a.name > b.name) ? 1 : -1)
                return copyArray
            }
            // Sort by date
            else if (this.sort == 4) {
                copyArray.sort(function(a,b){return Date.parse(b.date) - Date.parse(a.date)})
                return copyArray
            }
            else {
                return array
            }
             
        },*/
        getAvgRating(id) {
            /* Returns average rating & count */
            var ratingsArray = this.findRatingsFromWine(id)
            var sum = 0
            ratingsArray.forEach(rating => {
                sum += rating.rating
            });
            var avg = sum/ratingsArray.length
            avg = avg.toFixed(1)
            if (sum == 0) {
                avg = '-'
            }
            return { avg: avg, len: ratingsArray.length }
        },
        displayDate: function(timestamp) {
            if (timestamp) {
                timestamp = new Date(timestamp)
            return moment(timestamp).format('hh:mm DD/MM/YYYY')
            } else {
                return "DD/MM/YYYY hh:mm"
            }
            
        },
        openModal(wine) {
            this.currentWine.wine = wine
            this.currentWine.ratings = this.findRatingsFromWine(wine.id)
            this.modal = true
        },
        closeModal() {
            this.modal = false
            this.currentWine.wine = null
            this.currentWine.ratings = null
        }
    },
    filters: {
        optimizeWine: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_150/')
            return newUrl
        }
    }
}
</script>

<style>
#admin-ratings {
    width: 90%;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
}

.admin-ratings-col1 {
    width: 80%;
}
.admin-ratings-col1 h2 {
    margin-top: 0;
}
.admin-ratings-col2 {
    width: 20%;
}
.admin-ratings-col2 h2 {
    margin-top: 0;
}

.admin-ratings-wines {
    display:flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}
.admin-ratings-wines-single {
    width: 300px;
    height: 150px;
    background-color: white;
    margin: 5px;
    display: flex;
    cursor: pointer;
}
.admin-ratings-wines-img {
    height: 100%;
    width:20%;
}
.admin-ratings-wines-img img {
    height: 90%;
    margin-top: 10%;
}
.admin-ratings-wines-info {
    width: 80%;
    display: flex;
    flex-wrap: wrap;
}
.admin-ratings-wines-name {
    width: 100%;
    font-size: 18px;
    margin-top: 5px;
}
.admin-ratings-wines-avg-title {
    width: 50%;
    font-size: 14px;
    height: 20px;
    opacity: 80%;
}
.admin-ratings-wines-count-title {
    width: 50%;
    font-size: 14px;
    height: 20px;
    opacity: 80%;
}
.admin-ratings-wines-avg {
    width: 50%;
    font-size: 20px;
    margin-top: -20px;
}
.admin-ratings-wines-count {
    width: 50%;
    font-size: 20px;
    margin-top: -20px;
}
.admin-recent-ratings {
    max-height: 80vh;
    overflow-y: scroll;
    overflow-x: hidden;
}
.admin-single-rating {
    width: 100%;
    display: flex;
    padding: 5px;
    background-color: white;
    margin-bottom: 2px;
}
.admin-single-rating-img {
    width: 15px;
    padding-left: 5px;
}
.admin-single-rating-img img {
    width: 100%;
}
.admin-single-rating-info {
    width: 80%;
}
.admin-single-rating-rating {
    width: 10%;
    line-height: 50px;
}
.admin-single-rating-name {
    line-height: 30px;
}
.admin-ratings-modal-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.664)
}
.admin-ratings-modal {
    width: 500px;
    height: 500px;
    background-color: #f0f0f0;
    margin: 0 auto;
    margin-top: 20vh;
    position: relative;
}
.admin-ratings-modal-close {
    position: absolute;
    width: 500px;
    bottom: 0;
    margin: 0 auto;
    margin-bottom: 10px;
    margin-right: 30px;
    cursor: pointer;
    font-size: 20px;
}
.admin-ratings-modal-content {
    height: 450px;
    overflow-y: scroll;
    overflow-x: hidden;
    font-size: 20px;
}
.admin-ratings-modal-content div {
    
}
</style>